import React, { useEffect, useState, useContext } from 'react';
import { useOktaAuth } from '@okta/okta-react';
import SearchService from '../../../services/SearchService';
import LoadingContext from './loading-context';
import SearchDataContext from '../../../providers/searchData-context';
import { field } from '../../../types/Field';
import { Form } from 'react-bootstrap';

interface searchBy {
    coverageBegin: string;
    coverageEnd: string;
    description: string;
    fields: field[];
    name: string;
}
interface results {
    searchBys: searchBy[];
}

const SearchByPicker: React.FC = () => {
    const { oktaAuth, authState } = useOktaAuth();
    const [searchByList, setSearchByList] = useState<searchBy[]>();
    const loadingCtx = useContext(LoadingContext);
    const searchDataCtx = useContext(SearchDataContext);

    const uid: string = authState.accessToken.claims?.uid;
    //const userName: string = authState.accessToken.claims?.sub;
    const accessToken: string = authState.accessToken.accessToken;

    let triggers = [searchDataCtx.state, searchDataCtx.countyId, searchDataCtx.isReverse];

    if (!searchDataCtx.isReverse) {
        triggers.push(searchDataCtx.format);
        triggers.push(searchDataCtx.formatDescription);
    }

    useEffect(() => {
        if (!authState) return;

        setSearchByList(undefined);

        if (
            (!searchDataCtx.isReverse &&
                (searchDataCtx.state === '' ||
                    searchDataCtx.countyId === '' ||
                    searchDataCtx.format === '')) ||
            (searchDataCtx.isReverse &&
                (searchDataCtx.state === '' || searchDataCtx.countyId === ''))
        ) {
            return;
        }

        loadingCtx.setIsLoading(true, 'SearchByPicker');

        SearchService.getSearchBy(searchDataCtx.countyId, searchDataCtx.format, accessToken, uid)
            .then((response) => {
                const result = response as results;
                setSearchByList(result.searchBys);
                loadingCtx.setIsLoading(false, 'SearchByPicker');
            })
            .catch((ex) => {
                //setError(ex.response.data);
                //setIsError(true);
                loadingCtx.setIsLoading(false, 'SearchByPicker');
            });
    }, triggers);

    if (!authState) {
        return <div></div>;
    }

    const onChange = (e: any) => {
        const newSearchBy = e.target.value;
        const newSearchByDescription = e.target.text;
        searchDataCtx.setSearchBy(newSearchBy, newSearchByDescription);
    };

    return (
        <>
            <label>Search By</label>
            <div className='col'>
                <Form.Control
                    tabIndex={4}
                    id='search-select'
                    as='select'
                    className='form-select form-select-sm'
                    required
                    onChange={onChange}
                    value={searchDataCtx.searchBy}
                    name='searchby'
                >
                    <option value=''>Choose...</option>
                    {searchByList &&
                        searchByList.map((data) => (
                            <option key={data.name} value={data.name}>
                                {data.description}
                            </option>
                        ))}
                </Form.Control>
                <Form.Control.Feedback type='invalid'>
                    Please choose your Search By
                </Form.Control.Feedback>
            </div>
        </>
    );
};

export default SearchByPicker;
